import { colors } from '@lmc/common/constants'
import dayjs from 'dayjs'
import PropTypes from 'prop-types'
import React from 'react'
import { ProfilePicture } from '../../../../components/generic'

const HandoverNoteCard = ({ note }) => {
  const carer = note.carer
  if (!carer) return null
  return (
    <div style={styles.noteContainer}>
      <div style={styles.topContainer}>
        <div style={styles.carerContainer}>
          <ProfilePicture type="handover__small" url={carer.picture} />
          <span style={styles.carerName}>
            {carer.name.first} {carer.name.last}
          </span>
        </div>
        <div style={styles.timeContainer}>
          {dayjs(note.createdOn).format('HH:mm ddd')}
        </div>
      </div>
      <div style={styles.textContainer}>{note.note}</div>
    </div>
  )
}

const styles = {
  carerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start'
  },
  carerName: {
    fontSize: 14,
    position: 'relative',
    opacity: 0.5,
    top: 7,
    left: 15,
    margin: 0
  },
  noteContainer: {
    background: 'white',
    borderRadius: 10,
    border: `1px ${colors.grey} solid`,
    marginBottom: '0.6em',
    minHeight: 100,
    padding: 10,
    width: '100%'
  },
  textContainer: {
    fontSize: 12,
    opacity: 0.8,
    paddingTop: 10
  },
  timeContainer: {
    fontSize: 12,
    opacity: 0.5,
    padding: '7px 7px 0px 0px'
  },
  topContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  }
}

HandoverNoteCard.propTypes = {
  note: PropTypes.object.isRequired
}

export default HandoverNoteCard
